/**
 * MarkEditor markdown编辑器
 * @link 依赖（mavon-editor）：https://github.com/hinesboy/mavonEditor
 * @link 官方：http://www.mavoneditor.com/
 * @description Web 富文本编辑器
 */

import EdMarkEditor from './src/EdMarkEditor.vue'

/* istanbul ignore next */
EdMarkEditor.install = function (Vue) {
  Vue.component(EdMarkEditor.name, EdMarkEditor)
}

export default EdMarkEditor
